import { Action } from "@reduxjs/toolkit";
import { AuthState } from "./types";
import { isType } from "typescript-fsa";
import { authActions } from "./actions";

const initialState: AuthState = {
    isLoggedIn: false,
    loggedInUser: null,
    isInitialized: false,
}

export function AuthReducer(state = initialState, action: Action): AuthState {
    if (isType(action, authActions.login.done)) {
        return {
            ...state,
            isLoggedIn: true,
        }
    }

    if (isType(action, authActions.getUser.done)) {
        return {
            ...state,
            loggedInUser: action.payload.result,
        }
    }

    if (isType(action, authActions.setIsLoggedIn)) {
        return {
            ...state,
            isLoggedIn: action.payload,
            loggedInUser: action.payload ? state.loggedInUser : null,
        }
    }

    if (isType(action, authActions.setIsInitialized)) {
        return {
            ...state,
            isInitialized: action.payload,
        }
    }

    if (isType(action, authActions.logout.done)) {
        return {
            ...state,
            isLoggedIn: false,
            loggedInUser: null,
        }
    }


    if (isType(action, authActions.resetToInitialState)) {
        return initialState;
    }

    return state;
}